import { Termin } from '@/domain/termine/shared/types';
import dayjs from 'dayjs';

export function buildTerminOccurrence(
  termin: Termin,
  date: dayjs.Dayjs,
): Termin {
  const formattedDate = date.format('YYYY-MM-DD');
  const beginnTime = termin.beginn
    ? dayjs(termin.beginn).format('HH:mm:ss')
    : null;
  const endeTime =
    termin.beginn && termin.ende ? dayjs(termin.ende).format('HH:mm:ss') : null;

  return new Termin({
    ...termin,
    datum: formattedDate,
    beginn: beginnTime ? `${formattedDate}T${beginnTime}` : undefined,
    ende: endeTime ? `${formattedDate}T${endeTime}` : undefined,
    repetitionId: `${termin.id}_${formattedDate}`,
  });
}
